import { useQuery } from '@tanstack/react-query';
import { getEcrDashboard } from '@/api/dms/generated/sdk.gen';
import { useAuth } from '@/context/AuthContext';

export function useOpenEcrCount() {
  const { token } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['ecrs', 'open-count'],
    queryFn: async () => {
      const { data } = await getEcrDashboard({ throwOnError: true });
      const summary = data.summary;
      // Open = in_review (not yet implemented)
      return { count: summary.in_review };
    },
    enabled: !!token,
    refetchInterval: 60_000,
    retry: false,
  });

  return {
    count: data?.count ?? 0,
    isLoading,
  };
}
